import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ImageComp } from '../Image/Image';
import { INFO_CIRCLE } from '../../assets';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';

const IdOverlay = () => {

  const getStyles = useCssStyle();
  const { t } = useTranslation()

  return (
    <>
      <View style={getStyles([{...StyleSheet.absoluteFill}, 'id_instructionOverlayContainer'])}>
        <View style={getStyles(['id_instructionOverlayTop'])} />

        <View style={getStyles(['id_instructionOverlayMiddle'])}>
          <View style={getStyles(['id_instructionOverlayMiddleLeft'])} />
          <View style={getStyles(['id_instructionOverlayMiddleMiddle'])} />
          <View style={getStyles(['id_instructionOverlayMiddleRight'])} />
        </View>

        <View style={getStyles(['id_instructionOverlayBottom'])} />
      </View>


      <View style={getStyles(['id_instructionContainer'])}>
        <ImageComp source={INFO_CIRCLE} style={getStyles(['id_instructionInfoImage'])} />
        <Text style={getStyles(['id_instructionText'])}>{t('check_in.id_verification.id_overlay_instruction')}</Text>
      </View>
      </>
  );
};

export default IdOverlay;
